import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private promptEvent: unknown;
  updateAvailable = new BehaviorSubject<boolean>(false);

  private swUpdate = inject(SwUpdate);

  constructor() {
    window.addEventListener('beforeinstallprompt', event => {
      event.preventDefault();
      this.promptEvent = event;
    });

    // Check for updates
    this.swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        this.updateAvailable.next(true);
      });
  }

  installPwa(): void {
    const promptEvent = this.promptEvent as {
      prompt: () => void;
      userChoice?: Promise<{ outcome?: string }>;
    } | null;

    if (promptEvent) {
      promptEvent.prompt();
      promptEvent.userChoice?.then((choiceResult) => {
        if (choiceResult?.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.promptEvent = null;
      });
    }
  }

  updateApp(): void {
    if (this.swUpdate.isEnabled) {
      window.location.reload();
    }
  }

  checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }
}
